import { en } from "./en";
import { es } from "./es";

export const translations = {
  en,
  es,
};

export const getTranslation = (language = "en") => {
  return translations[language] || translations.en;
};
